import { render } from "./Finished_task.vue?vue&type=template&id=28bd42a0&scoped=true"
import script from "./Finished_task.vue?vue&type=script&lang=js"
export * from "./Finished_task.vue?vue&type=script&lang=js"

import "./Finished_task.vue?vue&type=style&index=0&id=28bd42a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bd42a0"]])

export default __exports__